export default __webpack_public_path__ + "static/media/38dc908ac99bd73d.4d5f4d2e8b016b8b760e23790a8e92d1.svg";